<div>
  <div class="pure-menu pure-menu-horizontal">
    <a href="" onClick="return false;" class="pure-menu-heading pure-menu-link">Onboarding</a>
  </div>
  <div class="pure-menu pure-menu-horizontal">
    <ul class="pure-menu-list">
      <li class="pure-menu-item" [ngClass]="{'pure-menu-selected': selected == 1}">
        <a class="pure-menu-link" (click)="assignComponent('transitTimeOnboardingComponent')">Transit Time
          Onboarding
        </a>

      </li>
    </ul>
  </div>

  <div>
    <ng-container *ngComponentOutlet="desiredComponent" [></ng-container>
  </div>

</div>
